import React from 'react';
import { useIntl } from 'react-intl';
import icon from '../../../../assets/external/svgicons/No-lientstitles.svg';
import { StyledPlaceholder, StyledTitle, StyledIcon } from './Styles';

const Placeholder = () => {
  const intl = useIntl();
  const placeholderTitle = intl.formatMessage({
    id: 'paymentsOnHold.greatNews'
  });
  const placeholderMessage = intl.formatMessage({
    id: 'paymentsOnHold.placeholderMessage'
  });

  return (
    <StyledPlaceholder>
      <StyledIcon src={icon} alt="no trades" />
      <div>
        <StyledTitle>{placeholderTitle}</StyledTitle>
        {placeholderMessage}
      </div>
    </StyledPlaceholder>
  );
};

export default Placeholder;
